import { IconDesktop } from '@arco-design/web-react/icon';

/** 与资源中心菜单「物理节点 / 计算资产」同一图标（列表 Avatar / 卡片传 React 组件，与菜单 SVG 一致） */
export const BARE_METAL_NODE_ICON = IconDesktop;
